import styled from 'styled-components'
import { Skeleton } from '~/components/shared'

export const PregnancyModalContainer = styled.div`
  .TitleModal {
    margin-bottom: 25px;
    font-size: 20px;
    font-weight: bold;
  }
  .SeparatorModal {
    margin-bottom: 25px;
  }
  .buttonSelectionModal {
    width: 100px;
    height: 30px;
    font-size: 14px;
    border: none;
    background: ${props => props.theme.colors.color378ff7};
    color: ${({ theme }) => theme.zds.colors.neutral1000};
    border-radius: ${({ theme }) => theme.zds.border.radius100};
    cursor: pointer;
    :disabled {
      opacity: 0.5;
    }
  }
`

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
`
export const SkeletonItem = styled(Skeleton).attrs(props => ({
  baseColor: props.theme.colors.colorf2f7ff
}))`
  margin-bottom: 10px;
  border-radius: 2px;
  margin-right: 8px;
`
export const ContentInLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
export const ContentInLineHeader = styled.div`
  display: flex;
  flex-direction: row;
  padding: 5px 0;
`
export const MessageContainer = styled.div`
  justify-content: center;
  display: flex;
`

export const EmptyMessage = styled.span`
  font-size: 0.8rem;
  color: ${props => props.theme.colors.color545e6c};
`
